"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nereto": {
    "5f792af7": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "certosa": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6b59937": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-capo-di-valle": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0cafc35e": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "parignano": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "331c7dfc": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "pignotto": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25767482": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "rote": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe81d46e": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "190e9c5e": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "san-savino": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6681d4b6": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "skipSearch": false
    }],
    "vibrata": [{
      "hkey": "ab4437d9",
      "slug": "nereto",
      "name": "Nereto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;